import { Injectable } from "@angular/core";
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class NavService {
  public currentUrl = new BehaviorSubject<string | undefined>(undefined);

  constructor(private router: Router) {
    // Fire the current URL on service start
    this.currentUrl.next(this.router.url);
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next((event as NavigationEnd).urlAfterRedirects);
      }

    });
  }
}
